
export default {
    NONE: 'NONE',
    UNAUTHORIZED: 'UNAUTHORIZED'
}

